import physical_LE_switch_640 from '../img/purchase/physical_LE_switch_640.jpg';
import physical_LE_switch_640_webp from '../img/purchase/physical_LE_switch_640.webp';
import physical_LE_switch_1280 from '../img/purchase/physical_LE_switch_1280.jpg';
import physical_LE_switch_1280_webp from '../img/purchase/physical_LE_switch_1280.webp';

import physical_SE_switch_640 from '../img/purchase/physical_SE_switch_640.png';
import physical_SE_switch_640_webp from '../img/purchase/physical_SE_switch_640.webp';
import physical_SE_switch_1280 from '../img/purchase/physical_SE_switch_1280.png';
import physical_SE_switch_1280_webp from '../img/purchase/physical_SE_switch_1280.webp';

import physical_SE_switch2_640 from '../img/purchase/physical_SE_switch2_640.png';
import physical_SE_switch2_640_webp from '../img/purchase/physical_SE_switch2_640.webp';
import physical_SE_switch2_1280 from '../img/purchase/physical_SE_switch2_1280.png';
import physical_SE_switch2_1280_webp from '../img/purchase/physical_SE_switch2_1280.webp';

import physical_SE_ps5_640 from '../img/purchase/physical_SE_ps5_640.png';
import physical_SE_ps5_640_webp from '../img/purchase/physical_SE_ps5_640.webp';
import physical_SE_ps5_1280 from '../img/purchase/physical_SE_ps5_1280.png';
import physical_SE_ps5_1280_webp from '../img/purchase/physical_SE_ps5_1280.webp';

import digital_640 from '../img/purchase/digital_640.jpg';
import digital_640_webp from '../img/purchase/digital_640.webp';
import digital_1280 from '../img/purchase/digital_1280.jpg';
import digital_1280_webp from '../img/purchase/digital_1280.webp';

import digital_switch2_640 from '../img/purchase/digital_switch2_640.jpg';
import digital_switch2_640_webp from '../img/purchase/digital_switch2_640.webp';
import digital_switch2_1280 from '../img/purchase/digital_switch2_1280.jpg';
import digital_switch2_1280_webp from '../img/purchase/digital_switch2_1280.webp';

import logo from '../img/common/hero_logo.png';

const purchaseImageList = [
  logo,
  physical_LE_switch_640,
  physical_LE_switch_640_webp,
  physical_LE_switch_1280,
  physical_LE_switch_1280_webp,

  physical_SE_switch_640,
  physical_SE_switch_640_webp,
  physical_SE_switch_1280,
  physical_SE_switch_1280_webp,

  physical_SE_switch2_640,
  physical_SE_switch2_640_webp,
  physical_SE_switch2_1280,
  physical_SE_switch2_1280_webp,

  physical_SE_ps5_640,
  physical_SE_ps5_640_webp,
  physical_SE_ps5_1280,
  physical_SE_ps5_1280_webp,

  digital_640,
  digital_640_webp,
  digital_1280,
  digital_1280_webp,

  digital_switch2_640,
  digital_switch2_640_webp,
  digital_switch2_1280,
  digital_switch2_1280_webp,
];

document.addEventListener('DOMContentLoaded', function () {
  const imageCache = {};

  function preloadImages() {
    const preloadContainerId = 'preload-container';

    // Create the container if it doesn't exist
    let container = document.getElementById(preloadContainerId);

    if (!container) {
      container = document.createElement('div');
      container.id = preloadContainerId;
      container.classList.add('visually-hidden');
      document.body.appendChild(container);
    } else {
      container.innerHTML = '';
    }

    purchaseImageList.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imageCache[src] = img;

        // Clone and insert into hidden DOM to guarantee caching
        const domImg = document.createElement('img');
        domImg.src = src;
        container?.appendChild(domImg);
      };
      img.onerror = (error) => {
        console.error(`Failed to load image: ${src}`, error);
      };
    });
  }
  preloadImages();
});

export const countryList = [
  {
    country_name: 'United States of America',
    country_id: 'usa',
    country_cookie: 'en',
  },
  {
    country_name: 'Canada',
    country_id: 'ca',
    country_cookie: 'ca',
  },
];

// NOTE: edition_id MUST include digital or physical in it.
export const editionsList = {
  en: [
    {
      edition_name: 'Physical Limited Edition',
      edition_id: 'physicalLimited',
    },
    {
      edition_name: 'Physical Standard Edition',
      edition_id: 'physicalStandard',
    },
    {
      edition_name: 'Digital Edition',
      edition_id: 'digitalStandard',
    },

    // {
    //   edition_name: 'Digital Deluxe Edition',
    //   edition_id: 'digitalDeluxe',
    // },
    // {
    //   edition_name: 'Digital Standard Edition',
    //   edition_id: 'digitalStandard',
    // },
  ],
  ca: [
    {
      edition_name: 'Physical Limited Edition',
      edition_id: 'physicalLimited',
    },
    {
      edition_name: 'Physical Standard Edition',
      edition_id: 'physicalStandard',
    },
    {
      edition_name: 'Digital Edition',
      edition_id: 'digitalStandard',
    },
  ],
};

export const platformsList = [
  {
    platform_name: 'Nintendo Switch',
    platform_id: 'switch',
    platform_cookie: 'switch',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
  },
  {
    platform_name: 'Nintendo Switch 2',
    platform_id: 'switch2',
    platform_cookie: 'switch2',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
  },
  {
    platform_name: 'PlayStation®5',
    platform_id: 'ps5',
    platform_cookie: 'ps5',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
  },
  {
    platform_name: 'Steam',
    platform_id: 'steam',
    platform_cookie: 'steam',
    digitalOnly: true,
    limitedEdition: false,
    digitalDeluxe: true,
  },
];

export const purchaseLinks = {
  en: {
    switch2: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-switch-2/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-limited-edition-nintendo-switch-2/J3R84YL9FZ',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NTQBWB/ref=sr_1_3?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-3',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch-2/products/muramasa-revenant-blades-limited-edition---nintendo-switch-2/448063.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/-/A-1012070929',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Muramasa-Revenant-Blades-Limited-Edition-Nintendo-Switch-2-Game/20407206571?classType=REGULAR&from=/search',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-nintendo-switch-2/J3R84YL9F6',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NHFC89/ref=sr_1_1?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa%2Brevenant%2Bblades&qid=1781041167&sprefix=muramasa%2Brevenant%2Bblad%2Caps%2C168&sr=8-1&th=1',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch-2/products/muramasa-revenant-blades---nintendo-switch-2/448052.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/-/A-1012070926',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Muramasa-Revenant-Blades-Nintendo-Switch-2-Game/20391464419?classType=REGULAR&from=/search',
          },
        ],
      },
    },
    switch: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-switch/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-digital-deluxe-edition-switch/',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-limited-edition-nintendo-switch/J3R84YL9F8',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NH233M/ref=sr_1_5?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa%2Brevenant%2Bblades&qid=1781042644&sprefix=muramasa%2Brevenant%2Bblad%2Caps%2C168&sr=8-5&th=1',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch/products/muramasa-revenant-blades-limited-edition---nintendo-switch/448059.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/-/A-1012070913',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Muramasa-Revenant-Blades-Limited-Edition-Nintendo-Switch-Game/20338272494?classType=REGULAR&from=/search',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-nintendo-switch/J3R84YL95V',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4P6P245/ref=sr_1_4?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-4',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/nintendo-switch/products/muramasa-revenant-blades---nintendo-switch/448048.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/-/A-1012070916',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Muramasa-Revenant-Blades-Nintendo-Switch-Game/20407206570?classType=REGULAR&from=/search',
          },
        ],
      },
    },
    steam: {
      digital: {
        digitalStandard: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        },
        // digitalDeluxe: {
        //   name: 'steam',
        //   link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        // },
      },
    },
    ps5: {
      digital: {
        digitalStandard: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10018932/',
        },
        // digitalDeluxe: {
        //   name: 'PlayStation Store',
        //   link: 'https://store.playstation.com/en-us/concept/10018932/',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-limited-edition-playstation-5/J3R84YL9VK',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NKZL9N/ref=sr_1_6?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-6',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/playstation-5/products/muramasa-revenant-blades-limited-edition---playstation-5/448061.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/-/A-1012070931',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Muramasa-Revenant-Blades-Limited-Edition-PlayStation-5-Game/20391464418?classType=REGULAR&from=/search',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-playstation-5/J3R84YL9V9',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NLLCLQ/ref=sr_1_7?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-7',
          },
          {
            name: 'GameStop',
            link: 'https://www.gamestop.com/video-games/playstation-5/products/muramasa-revenant-blades---playstation-5/448050.html',
          },
          {
            name: 'Target',
            link: 'https://www.target.com/p/-/A-1012070930',
          },
          {
            name: 'Walmart',
            link: 'https://www.walmart.com/ip/Muramasa-Revenant-Blades-PlayStation-5-Game/20338272492?classType=REGULAR&from=/search',
          },
        ],
      },
    },
  },
  ca: {
    switch2: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-switch-2/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Muramasa-Revenant-Blades-Limited-Nintendo/dp/B0H4NTQBWB/ref=sr_1_3?crid=123V18861V3MM&dib=eyJ2IjoiMSJ9.Cheq1Te0msmc0i-muhAbXT8kSei3zt5kAkX9iDykxddqovKFm3HJUtr1hsl34EERN4hS22APYGaCitd1n24A3HYFndvGmzuDn6EQq12NuBTnqIbqkW7T44N6UoX99r7crQNrZ_W-1Xp9MHua1WBgRZRfd3e5WNk8M64MLwi8rmAXcSmkQ4wRiFku536Vz6ozIAErDv3g9vl3b8opl7K7GOg_mpdfquD1jeNBoOu9rXU7Bq_fvpLHoUxmed9oM5DIpJ06wqRHeKIGAvbCF5PMNUnA4NvM1_koiFRwcO_S3J8.RWHEGXFkl8gmMPYUz8H402ZW586T5lgKv0PXkcLqAcQ&dib_tag=se&keywords=muramasa%3A+revenant+blade&qid=1782233454&sprefix=%2Caps%2C131&sr=8-3',
          },
          {
            name: 'EB Games (CA)',
            link: 'https://www.ebgames.ca/Switch%202/Games/968740/muramasa-revenant-blades-limited-edition',
          },
        ],
        physicalStandard: [
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Muramasa-Revenant-Blades-Nintendo-Switch/dp/B0H4NHFC89/ref=sr_1_2?crid=123V18861V3MM&dib=eyJ2IjoiMSJ9.Cheq1Te0msmc0i-muhAbXT8kSei3zt5kAkX9iDykxddqovKFm3HJUtr1hsl34EERN4hS22APYGaCitd1n24A3HYFndvGmzuDn6EQq12NuBTnqIbqkW7T44N6UoX99r7crQNrZ_W-1Xp9MHua1WBgRZRfd3e5WNk8M64MLwi8rmAXcSmkQ4wRiFku536Vz6ozIAErDv3g9vl3b8opl7K7GOg_mpdfquD1jeNBoOu9rXU7Bq_fvpLHoUxmed9oM5DIpJ06wqRHeKIGAvbCF5PMNUnA4NvM1_koiFRwcO_S3J8.RWHEGXFkl8gmMPYUz8H402ZW586T5lgKv0PXkcLqAcQ&dib_tag=se&keywords=muramasa%3A+revenant+blade&qid=1782233454&sprefix=%2Caps%2C131&sr=8-2',
          },
          {
            name: 'EB Games (CA)',
            link: 'https://www.ebgames.ca/Switch%202/Games/968741/muramasa-revenant-blades',
          },
        ],
      },
    },
    switch: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-switch/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-digital-deluxe-edition-switch/',
        // },
      },
      physical: {
        physicalLimited: [
          // {
          //   name: 'Marvelous-USA Store',
          //   link: '',
          // },
          // {
          //   name: 'GameStop (CA)',
          //   link: 'https://www.gamestop.ca/Switch/Games/926945/rune-factory-guardians-of-azuma-earth-dancer-limited-edition',
          // },
          // {
          //   name: 'VGP.CA',
          //   link: '',
          // },
          // {
          //   name: 'PNP Games Online',
          //   link: '',
          // },
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Muramasa-Revenant-Blades-Limited-Nintendo/dp/B0H4NH233M/ref=sr_1_6?crid=123V18861V3MM&dib=eyJ2IjoiMSJ9.Cheq1Te0msmc0i-muhAbXT8kSei3zt5kAkX9iDykxddqovKFm3HJUtr1hsl34EERN4hS22APYGaCitd1n24A3HYFndvGmzuDn6EQq12NuBTnqIbqkW7T44N6UoX99r7crQNrZ_W-1Xp9MHua1WBgRZRfd3e5WNk8M64MLwi8rmAXcSmkQ4wRiFku536Vz6ozIAErDv3g9vl3b8opl7K7GOg_mpdfquD1jeNBoOu9rXU7Bq_fvpLHoUxmed9oM5DIpJ06wqRHeKIGAvbCF5PMNUnA4NvM1_koiFRwcO_S3J8.RWHEGXFkl8gmMPYUz8H402ZW586T5lgKv0PXkcLqAcQ&dib_tag=se&keywords=muramasa%3A+revenant+blade&qid=1782233454&sprefix=%2Caps%2C131&sr=8-6',
          },
          {
            name: 'EB Games (CA)',
            link: 'https://www.ebgames.ca/Switch/Games/968742/muramasa-revenant-blades-limited-edition',
          },
        ],
        physicalStandard: [
          // {
          //   name: 'Marvelous-USA Store',
          //   link: '',
          // },
          // {
          //   name: 'GameStop (CA)',
          //   link: 'https://www.gamestop.ca/Switch/Games/926944/rune-factory-guardians-of-azuma',
          // },
          // {
          //   name: 'VGP.CA',
          //   link: '',
          // },
          // {
          //   name: 'PNP Games Online',
          //   link: '',
          // },
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Muramasa-Revenant-Blades-Nintendo-Switch/dp/B0H4P6P245/ref=sr_1_5?crid=123V18861V3MM&dib=eyJ2IjoiMSJ9.Cheq1Te0msmc0i-muhAbXT8kSei3zt5kAkX9iDykxddqovKFm3HJUtr1hsl34EERN4hS22APYGaCitd1n24A3HYFndvGmzuDn6EQq12NuBTnqIbqkW7T44N6UoX99r7crQNrZ_W-1Xp9MHua1WBgRZRfd3e5WNk8M64MLwi8rmAXcSmkQ4wRiFku536Vz6ozIAErDv3g9vl3b8opl7K7GOg_mpdfquD1jeNBoOu9rXU7Bq_fvpLHoUxmed9oM5DIpJ06wqRHeKIGAvbCF5PMNUnA4NvM1_koiFRwcO_S3J8.RWHEGXFkl8gmMPYUz8H402ZW586T5lgKv0PXkcLqAcQ&dib_tag=se&keywords=muramasa%3A+revenant+blade&qid=1782233454&sprefix=%2Caps%2C131&sr=8-5',
          },
          {
            name: 'EB Games (CA)',
            link: 'https://www.ebgames.ca/Switch/Games/968743/muramasa-revenant-blades',
          },
        ],
      },
    },
    steam: {
      digital: {
        digitalStandard: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        },
        // digitalDeluxe: {
        //   name: 'steam',
        //   link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        // },
      },
    },
    ps5: {
      digital: {
        digitalStandard: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10018932/',
        },
        // digitalDeluxe: {
        //   name: 'PlayStation Store',
        //   link: 'https://store.playstation.com/en-ca/concept/10018932',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Muramasa-Revenant-Blades-Limited-PlayStation/dp/B0H4NKZL9N/ref=sr_1_1?crid=123V18861V3MM&dib=eyJ2IjoiMSJ9.Cheq1Te0msmc0i-muhAbXT8kSei3zt5kAkX9iDykxddqovKFm3HJUtr1hsl34EERN4hS22APYGaCitd1n24A3HYFndvGmzuDn6EQq12NuBTnqIbqkW7T44N6UoX99r7crQNrZ_W-1Xp9MHua1WBgRZRfd3e5WNk8M64MLwi8rmAXcSmkQ4wRiFku536Vz6ozIAErDv3g9vl3b8opl7K7GOg_mpdfquD1jeNBoOu9rXU7Bq_fvpLHoUxmed9oM5DIpJ06wqRHeKIGAvbCF5PMNUnA4NvM1_koiFRwcO_S3J8.RWHEGXFkl8gmMPYUz8H402ZW586T5lgKv0PXkcLqAcQ&dib_tag=se&keywords=muramasa%3A+revenant+blade&qid=1782233454&sprefix=%2Caps%2C131&sr=8-1',
          },
          {
            name: 'EB Games (CA)',
            link: 'https://www.ebgames.ca/PS5/Games/968738/muramasa-revenant-blades-limited-edition',
          },
        ],
        physicalStandard: [
          {
            name: 'Amazon.CA',
            link: 'https://www.amazon.ca/Muramasa-Revenant-Blades-PlayStation-5/dp/B0H4NLLCLQ/ref=sr_1_4?crid=123V18861V3MM&dib=eyJ2IjoiMSJ9.Cheq1Te0msmc0i-muhAbXT8kSei3zt5kAkX9iDykxddqovKFm3HJUtr1hsl34EERN4hS22APYGaCitd1n24A3HYFndvGmzuDn6EQq12NuBTnqIbqkW7T44N6UoX99r7crQNrZ_W-1Xp9MHua1WBgRZRfd3e5WNk8M64MLwi8rmAXcSmkQ4wRiFku536Vz6ozIAErDv3g9vl3b8opl7K7GOg_mpdfquD1jeNBoOu9rXU7Bq_fvpLHoUxmed9oM5DIpJ06wqRHeKIGAvbCF5PMNUnA4NvM1_koiFRwcO_S3J8.RWHEGXFkl8gmMPYUz8H402ZW586T5lgKv0PXkcLqAcQ&dib_tag=se&keywords=muramasa%3A+revenant+blade&qid=1782233454&sprefix=%2Caps%2C131&sr=8-4',
          },
          {
            name: 'EB Games (CA)',
            link: 'https://www.ebgames.ca/PS5/Games/968739/muramasa-revenant-blades',
          },
        ],
      },
    },
  },
};

export const comingSoon = {
  en: 'Links Coming Soon',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const switchSoon = {
  en: 'Physical Pre-Orders will be Available Soon!',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const editionsInfo = {
  en: {
    switch2: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch2_640,
        image_1280: physical_SE_switch2_1280,
        image_640_webp: physical_SE_switch2_640_webp,
        image_1280_webp: physical_SE_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    switch: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch_640,
        image_1280: physical_SE_switch_1280,
        image_640_webp: physical_SE_switch_640_webp,
        image_1280_webp: physical_SE_switch_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    ps5: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_ps5_640,
        image_1280: physical_SE_ps5_1280,
        image_640_webp: physical_SE_ps5_640_webp,
        image_1280_webp: physical_SE_ps5_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    steam: {
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
  },
  ca: {
    switch2: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch2_640,
        image_1280: physical_SE_switch2_1280,
        image_640_webp: physical_SE_switch2_640_webp,
        image_1280_webp: physical_SE_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    switch: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch_640,
        image_1280: physical_SE_switch_1280,
        image_640_webp: physical_SE_switch_640_webp,
        image_1280_webp: physical_SE_switch_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    ps5: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_ps5_640,
        image_1280: physical_SE_ps5_1280,
        image_640_webp: physical_SE_ps5_640_webp,
        image_1280_webp: physical_SE_ps5_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    steam: {
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
  },
};
